import * as React from 'react';
import {
    Button,
    Link,
    Typography,
    FormControl,
    Stack,
    IconButton,
    Divider,
    TextField,
    Tooltip,
    CircularProgress,
    Modal,
    Box
} from '@mui/material';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { useState, useEffect } from 'react';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import InfoIcon from '@mui/icons-material/Info';
import VerifiedIcon from '@mui/icons-material/Verified';
// import GoogleIcon from '@mui/icons-material/Google';

// import ChildrenImage from '../images/authentication.svg';
// import Image from 'material-ui-image';
import { useForm } from 'react-hook-form';
import usersEndpoints from '../../../services/userServices';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import jwtDecode from 'jwt-decode';
import HandleOtp from '../../common/otphandler/HandleOtp';
import DiscountOutlinedIcon from '@mui/icons-material/DiscountOutlined';
// const config = require("../../../config/settings.json");

/*global chrome*/
/*global google*/

/* ── Shared dark-field style ────────────────────────────── */
const darkFieldSx = {
    '& .MuiOutlinedInput-root': {
        bgcolor:      'rgba(255,255,255,0.05)',
        borderRadius: '10px',
        color:        'white',
        '& fieldset':              { borderColor: 'rgba(255,255,255,0.12)' },
        '&:hover fieldset':        { borderColor: 'rgba(255,255,255,0.22)' },
        '&.Mui-focused fieldset':  { borderColor: '#FF6B35', borderWidth: '1.5px' },
        '&.Mui-disabled .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255,255,255,0.08)' },
    },
    '& .MuiInputBase-input': {
        color: 'white',
        '&::placeholder': { color: 'rgba(255,255,255,0.35)', opacity: 1 },
        '&.Mui-disabled': { WebkitTextFillColor: 'rgba(255,255,255,0.30)' },
    },
    '& .MuiFormHelperText-root': { color: '#ff6060', fontSize: '12px', ml: 0 },
};

function SignupSection({ refCode }){
    // const [ otpTimer, setOtpTimer ] = useState(30);
    // const [ otpEnterSection, setOtpEnterSection ] = useState(false);
    const [passwordType, setPasswordType] = useState('password');
    const [loading, setLoading] = useState(false);
    const [showOtherFields, setShowOtherFields] = useState(false);
    const [emailOtp, setEmailOtp] = useState(false);
    const [emailModalDetails, setEmailModalDetails] = useState({});
    const [otpLoading, setOtpLoading] = useState(false);
    const [refCodeStatus, setRefCodeStatus] = useState(false);

    const navigate = useNavigate();
    const [cookies, setCookie] = useCookies(["user", "auth", "logindata"]);

    const SPACE_KEY = " ";
    const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_ID_SIGNIN;

    const { register, handleSubmit, watch, formState: { errors }, setError, getValues } = useForm();

    const onSubmit = async (data) => {
        setLoading(true);
        const check_disposable = await axios({
            url: `https://disposable.debounce.io/?email=${ data.user_email }`,
            method: 'GET'
        });

        if(check_disposable['data']['disposable'] === "false"){
            handleSignup(data);
        }
        else{
            setLoading(false);
            setError(
                'user_email',
                {
                    type: "custom",
                    message: "Email address should be a valid business address"
                },
                {
                    shouldFocus: true
                }
            );
        }
    };

    const showInvalidValues = (data) => {

    };

    const handleChangePasswordType = () => {
        let type_attr = '';
        if(passwordType === 'password'){
            type_attr = 'text';
        }
        else{
            type_attr = 'password';
        }
        setPasswordType(type_attr);
    };

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {

        });

        return () => { subscription.unsubscribe() }
    }, [watch]);

    useEffect(() => {
        if(refCode){
            verifyReferralCode();
        }
    }, [refCode]);

    const handleSpaceInInput = (event) => {
        let keyCode = event.keyCode || event.which;
        keyCode = String.fromCharCode(keyCode);
        if(keyCode === SPACE_KEY){
            event.returnValue = false;
            if(event.preventDefault){
                event.preventDefault();
            }
        }
    };

    const handleSignup = async (data) => {
        let postdata = {
            "firstname": data.user_first_name,
            "lastname": data.user_last_name,
            "email": data.user_email,
            "phone": data.user_phone_number || '',
            "password": data.user_password,
            "isverified": false,
            'code': refCode ? refCode : ''
        };

        const response = await usersEndpoints.signUpUser(postdata);
        setLoading(false);
        saveSignupData(response);
    };

    const handleGoogleLoginResponse = async (response) => {
        if(response.credential){
            const details = jwtDecode(response.credential);
            if(details.hd){
                // send token to server for verification and further login/registration process
                let headers = { headers: { "user-auth": response.credential } };
                const postdata = {
                    mode: 'gauth',
                    page: 'signup',
                    code: refCode ? refCode : ''
                };

                const signup_info = await usersEndpoints.signInUser(postdata, headers);
                saveSignupData(signup_info);
            }
            else{
                // alert('Please join using a business email address');
                toast.error('Please join using a business email address');
            }
        }
    }

    useEffect(() => {
        window.onGoogleLibraryLoad = () => {
            google.accounts.id.initialize({
                client_id: GOOGLE_CLIENT_ID,
                callback: data => handleGoogleLoginResponse(data),
                cancel_on_tap_outside: false
            });

            google.accounts.id.renderButton(
                document.getElementById('google_sign_in'),
                {
                    theme: "filled_blue",
                    size: "large",
                    text: "continue_with"
                }
            );

            google.accounts.id.prompt();
        }
    }, []);

    const saveSignupData = (response) => {
        if(response && response['success'] === true){
            let cookieData = {
                name: response['loginData']['fullname'],
                _id: response['loginData']['user_id']
            };

            setCookie("user", JSON.stringify(cookieData), {
                path: "/",
                secure: false,
                maxAge: 2592000
            });

            setCookie("auth",
            { "token": response['loginData']['jwttoken'] },
            {
                path: "/",
                secure: false,
                maxAge: 2592000
            });

            try{
                chrome.runtime.sendMessage(
                process.env.REACT_APP_EXTENSION_ID,
                {
                    message: 'login_successful',
                    loginData: response['loginData']
                },
                function(responseFromExtension){
                    responseFromExtension = responseFromExtension || {};
                    window.close();
                });
            }
            catch(error){
                setCookie("logindata", response['loginData'], { path: "/", secure: false, maxAge: 2592000 });
            }
            navigate('/');
        }
        else{
            // alert(response["message"]);
            toast.error(response['message']);
        }
    }

    const checkEmail = async () => {
        try{
            setOtpLoading(true);
            const formValues = getValues();
            setShowOtherFields(false);
            if(formValues['user_email']){
                const check_disposable = await axios({
                    url: `https://disposable.debounce.io/?email=${ formValues.user_email }`,
                    method: 'GET'
                });

                if(check_disposable['data']['disposable'] === "false"){
                    let postdata = {
                        email: formValues.user_email,
                        mode: 'signup'
                    };

                    const response = await usersEndpoints.sendLoginOTP(postdata);
                    if(response['success'] === true){
                        toast.success(
                            'OTP has been successfully sent on your Email'
                        );
                        setEmailModalDetails({
                            email: formValues.user_email
                        });
                        setEmailOtp(true);
                    }
                    else{
                        toast.error(response['message'])
                    }
                }
            }
        }
        catch(error){
            toast.error(error.message);
        }
        finally{
            setOtpLoading(false);
        }
    }

    const verifyEmailOtp = async (otpCode) => {
        setEmailModalDetails({ ...emailModalDetails, ...{ verifying: true } });

        let postdata = {
            email: emailModalDetails['email'],
            code: otpCode
        };

        const response = await usersEndpoints.verifyEmailCode(postdata);
        setEmailModalDetails({ ...emailModalDetails, ...{ verifying: false } });
        if(response['success'] === true){
            toast.success(response['message']);
            setEmailOtp(false);
            setShowOtherFields(true);
        }
        else{
            toast.error(
                response['message']
            );
        }
    };

    const verifyReferralCode = async () => {
        const response = await usersEndpoints.verifyReferralCode({ code: refCode });
        setRefCodeStatus(response['success']);
        if(response['success'] === false){
            toast.error(
                "Referral Code is Expired/Invalid. You can still proceed with Registration and Get Welcome Bonus of 5 Credits",
                {
                    'position': 'top-left'
                }
            )
        }
    }

    return(
        <>
            {/* ── Header ── */}
            <Box sx={{ textAlign: 'center', mb: 3 }}>
                <Typography
                    variant='h5'
                    component='h5'
                    sx={{ fontWeight: 700, color: 'white', mb: 0.75, fontSize: '21px' }}
                >
                    Create your account
                </Typography>
                <Typography sx={{ fontSize: '13px', color: 'rgba(255,255,255,0.38)' }}>
                    Already have an account?{' '}
                    <Link
                        href="/authenticate/signin"
                        sx={{ color: '#FF6B35', fontWeight: 600, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                    >
                        Sign in
                    </Link>
                </Typography>
            </Box>

            {/* ── Google SSO (prominent, above the fold) ── */}
            <Stack id='google_sign_in' alignItems="center" sx={{ mb: 2.5, minHeight: '44px' }} />

            {/* ── OR divider ── */}
            <Divider
                sx={{
                    mb: 2.5,
                    '&::before, &::after': { borderColor: 'rgba(255,255,255,0.09)' },
                    color:    'rgba(255,255,255,0.28)',
                    fontSize: '11px',
                    fontWeight: 500,
                    letterSpacing: '0.04em',
                }}
            >
                or continue with email
            </Divider>

            {/* ── Referral badge ── */}
            {
                refCode && refCodeStatus &&
                <Box sx={{
                    display: 'flex', alignItems: 'center', gap: 1,
                    px: 1.5, py: 0.8,
                    bgcolor: 'rgba(34,197,94,0.10)',
                    border:  '1px solid rgba(34,197,94,0.22)',
                    borderRadius: '8px',
                    mb: 2, width: 'fit-content',
                }}>
                    <DiscountOutlinedIcon fontSize='small' sx={{ color: '#22C55E', fontSize: '15px', opacity: 0.85 }} />
                    <Typography fontSize='13px' fontWeight={600} sx={{ color: '#22C55E' }}>
                        {refCode} Applied
                    </Typography>
                </Box>
            }

            {/* ── Form ── */}
            <form onSubmit={ handleSubmit(onSubmit, showInvalidValues) }>

                {/* Email + Verify */}
                <FormControl sx={{ width: '100%', mb: 2 }}>
                    <TextField
                        variant="outlined"
                        id='email_address_signup'
                        placeholder='Work email address'
                        { ...register("user_email", {
                            required: {
                                value: true,
                                message: 'Email field cannot be empty'
                            },
                            pattern: {
                                value: /^(?!.+@(gmail|google|yahoo|outlook|hotmail|msn)\..+)(.+@.+\..+)$/,
                                message: "Please provide a business email address"
                            }
                        }) }
                        error={ Boolean(errors.user_email) }
                        helperText={ errors.user_email?.message }
                        autoComplete={ "off" }
                        onKeyPress={ handleSpaceInInput }
                        autoFocus
                        disabled={ showOtherFields }
                        InputProps={{
                            endAdornment: (
                                showOtherFields === false ?
                                <Button
                                    size='small'
                                    onClick={ checkEmail }
                                    endIcon={
                                        otpLoading &&
                                        <CircularProgress size='0.75rem' sx={{ color: 'white' }} />
                                    }
                                    sx={{
                                        background:    'linear-gradient(135deg, #FF6B35 0%, #FF4500 100%)',
                                        color:         'white',
                                        fontWeight:    700,
                                        fontSize:      '12px',
                                        px:            '14px',
                                        py:            '6px',
                                        borderRadius:  '7px',
                                        textTransform: 'none',
                                        flexShrink:    0,
                                        minWidth:      'unset',
                                        '&:hover': { background: 'linear-gradient(135deg, #e85520 0%, #cc3300 100%)' },
                                    }}
                                >
                                    Verify
                                </Button>
                                :
                                <VerifiedIcon sx={{ color: '#22C55E', fontSize: '1.25rem' }} />
                            )
                        }}
                        sx={ darkFieldSx }
                    />
                </FormControl>

                {/* First + Last name (post-verify) */}
                {
                    showOtherFields &&
                    <Stack direction='row' spacing={1.5} sx={{ mb: 2 }}>
                        <FormControl sx={{ width: '100%' }}>
                            <TextField
                                variant='outlined'
                                id='firstname_input'
                                placeholder='First Name'
                                {
                                    ...register("user_first_name", {
                                        required: 'Please provide your first name',
                                        maxLength: {
                                            value: 30,
                                            message: 'First name cannot be more than 30 characters'
                                        }
                                    })
                                }
                                error={ Boolean(errors.user_first_name) }
                                helperText={ errors.user_first_name?.message }
                                autoComplete={ "off" }
                                onKeyPress={ handleSpaceInInput }
                                sx={ darkFieldSx }
                            />
                        </FormControl>
                        <FormControl sx={{ width: '100%' }}>
                            <TextField
                                variant='outlined'
                                id='lastname_input'
                                placeholder='Last Name'
                                {
                                    ...register("user_last_name", {
                                        required: 'Please provide your last name',
                                        maxLength: {
                                            value: 30,
                                            message: 'Last name cannot be more than 30 characters'
                                        }
                                    })
                                }
                                error={ Boolean(errors.user_last_name) }
                                helperText={ errors.user_last_name?.message }
                                autoComplete={ "off" }
                                onKeyPress={ handleSpaceInInput }
                                sx={ darkFieldSx }
                            />
                        </FormControl>
                    </Stack>
                }

                {/* Password + Submit (post-verify) */}
                {
                    showOtherFields &&
                    <>
                        <FormControl sx={{ width: '100%', mb: 2 }}>
                            <TextField
                                variant='outlined'
                                placeholder='Create a password'
                                type={ passwordType }
                                InputProps={{
                                    endAdornment: (
                                        <IconButton
                                            onClick={ handleChangePasswordType }
                                            sx={{ color: 'rgba(255,255,255,0.45)' }}
                                        >
                                            { passwordType === 'password' ? <RemoveRedEyeOutlinedIcon fontSize='small'/> : <VisibilityOffOutlinedIcon fontSize='small'/> }
                                        </IconButton>
                                    ),
                                    startAdornment: (
                                        <Tooltip title="Min 8 chars — uppercase, lowercase & number">
                                            <IconButton sx={{ color: 'rgba(255,255,255,0.28)' }}>
                                                <InfoIcon fontSize='small'/>
                                            </IconButton>
                                        </Tooltip>
                                    )
                                }}
                                {
                                    ...register("user_password", {
                                        required: 'Please select a password',
                                        minLength: {
                                            value: 8,
                                            message: 'Password should contain atleast 8 characters'
                                        },
                                        maxLength: {
                                            value: 20,
                                            message: 'Password length cannot be more than 20'
                                        },
                                        pattern: {
                                            value: new RegExp('(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])'),
                                            message: 'Password should be of 8 characters in length and must contain atleast 1 Uppercase letter, 1 lowercase letter and 1 digit'
                                        }
                                    })
                                }
                                error={ Boolean(errors.user_password) }
                                helperText={ errors.user_password?.message }
                                autoComplete={ "off" }
                                onKeyPress={ handleSpaceInInput }
                                sx={ darkFieldSx }
                            />
                        </FormControl>

                        <Button
                            type="submit"
                            fullWidth
                            endIcon={
                                <CircularProgress
                                    size={ loading ? '0.9rem' : '0rem' }
                                    sx={{ color: 'white' }}
                                />
                            }
                            sx={{
                                background:    'linear-gradient(135deg, #FF6B35 0%, #FF4500 100%)',
                                color:         'white',
                                fontWeight:    700,
                                fontSize:      '15px',
                                py:            1.6,
                                borderRadius:  '10px',
                                textTransform: 'none',
                                mb:            2,
                                '&:hover': {
                                    background: 'linear-gradient(135deg, #e85520 0%, #cc3300 100%)',
                                    boxShadow:  '0 8px 30px rgba(255,107,53,0.40)',
                                },
                                transition: 'all 0.2s ease',
                            }}
                        >
                            Create account
                        </Button>
                    </>
                }
            </form>

            {/* ── Terms ── */}
            <Typography sx={{ fontSize: '11px', color: 'rgba(255,255,255,0.22)', textAlign: 'center', mt: 1 }}>
                By signing up you agree to our{' '}
                <Box component="a" href="/privacy_policy" sx={{ color: 'rgba(255,255,255,0.40)', textDecoration: 'underline' }}>
                    Privacy Policy
                </Box>
                {' '}and{' '}
                <Box component="a" href="/terms_of_use" sx={{ color: 'rgba(255,255,255,0.40)', textDecoration: 'underline' }}>
                    Terms of Service
                </Box>
            </Typography>

            <Modal
                open={ emailOtp }
                onClose={ () => setEmailOtp(false) }
                children={ <HandleOtp verifyOtp={verifyEmailOtp} details={ emailModalDetails }/> }
                onBackdropClick={ () => { return false } }
            />

            <ToastContainer style={{ fontSize: '0.85rem' }} />
        </>
    );
}

export default SignupSection;
